import { removeCounty } from '@src/utils';

export const REPORT_CHART_FONT = {
  family: 'Arial',
  size: 14,
  weight: 400,
} as const;

export const REPORT_CHART_TEXT_STYLE = {
  fontFamily: 'Arial, sans-serif',
  fontSize: 14,
  fontWeight: 400,
} as const;

export const REPORT_METRIC_TITLE_STYLE = {
  color: '#fff',
  fontFamily: 'Arial, sans-serif',
  fontSize: '12px',
  lineHeight: '20px',
  fontWeight: 400,
} as const;

export const REPORT_METRIC_VALUE_STYLE = {
  color: '#fff',
  fontFamily: 'Arial, sans-serif',
  fontSize: '20px',
  lineHeight: '30px',
  fontWeight: 600,
} as const;

export const incompleteChartLabels = ['driver no show', 'member no show'];

export const buildCountyCostChart = (data: any[]) => {
  const newLabels =
    data?.flatMap((item) =>
      Object.values(item)
        ?.flatMap((values: any) => values)
        ?.map((el) => removeCounty(el.label as string))
    ) ?? [];

  const newDatasets = data?.flatMap(
    (item) =>
      Object.entries(item).map(([key, values]: [string, any], index) => {
        if (key === 'Unknown')
          return { label: '', data: [], borderColor: 'green' };
        return {
          label: key,
          data: values?.map((el) => el.cost) ?? [],
          borderColor: assetColorByIndex(index),
        };
      }) ?? []
  );

  return { labels: [...new Set(newLabels)], datasets: newDatasets ?? [] };
};
const GOLDEN_ANGLE = 137.508;

export function assetColorByIndex(index: number): string {
  const hue = (index * GOLDEN_ANGLE) % 360;

  const saturation = 40;
  const lightness = 50;

  return `hsl(${hue.toFixed(1)}, ${saturation}%, ${lightness}%)`;
}
